import {
  Airi,
  Akane,
  Akari,
  Ako,
  Aris,
  Aru,
  AruNewyear,
  Asuna,
  Asuna_Bunny_Girl,
  Ayane,
  Azusa,
  Azusa_Swimsuit,
  Cherino,
  CherinoHotSpring,
  Chihiro,
  Chinatsu,
  ChinatsuHotSpring,
  Chise,
  Eimi,
  Fubuki,
  Fuuka,
  Hanae,
  Hanako,
  Hare,
  Haruka,
  Haruna,
  Hasumi,
  Hatsune_Miku,
  Hibiki,
  Hihumi,
  Hihumi_Swimsuit,
  Hina,
  Hina_Swimsuit,
  Hoshino,
  Iori,
  Iori_Swimsuit,
  Izumi,
  Izumi_Swimsuit,
  Izuna,
  Juri,
  Karin,
  Karin_Bunny_Girl,
  Kayoko,
  Kirino,
  Koharu,
  Kotama,
  Kotori,
  Maki,
  Mari,
  Mashiro,
  Mashiro_Swimsuit,
  Midori,
  Momoi,
  Mutsuki,
  MutsukiNewyear,
  Natsu,
  Neru,
  Neru_Bunny_Girl,
  Nodoka,
  NodokaHotSpring,
  Nonomi,
  Pina,
  Saya,
  Saya_Casual,
  Sena,
  Serika,
  Serika_Newyear,
  Serina,
  Shimiko,
  Shiroko,
  Shiroko_Ridingsuit,
  Shizuko,
  Shun,
  Shun_Young,
  Sumire,
  Suzumi,
  Tomoe,
  Tsubaki,
  Tsurugi,
  Tsurugi_Swimsuit,
  Utaha,
  Wakamo,
  Yoshimi,
  Yuuka,
  Yuzu,
  Zunko
} from './images'

type EntryDict = {
  [key in string]: MotionEntryFields
}

export const entry: EntryDict = {
  hoge: 'gsx$その他'
}

type CharacterIdDict = {
  [key in string]: {
    name: string
    image: string
  }
}

export const characterIdDict: CharacterIdDict = {
  Akane: { name: 'アカネ', image: Akane },
  Akari: { name: 'アカリ', image: Akari },
  Ako: { name: 'アコ', image: Ako },
  Asuna: { name: 'アスナ', image: Asuna },
  Asuna_Bunny_Girl: { name: 'アスナ(バニーガール)', image: Asuna_Bunny_Girl },
  Azusa: { name: 'アズサ', image: Azusa },
  Azusa_Swimsuit: { name: 'アズサ(水着)', image: Azusa_Swimsuit },
  Aris: { name: 'アリス', image: Aris },
  Aru: { name: 'アル', image: Aru },
  AruNewyear: { name: 'アル(正月)', image: AruNewyear },
  Iori: { name: 'イオリ', image: Iori },
  Iori_Swimsuit: { name: 'イオリ(水着)', image: Iori_Swimsuit },
  Izuna: { name: 'イズナ', image: Izuna },
  Izumi: { name: 'イズミ', image: Izumi },
  Izumi_Swimsuit: { name: 'イズミ(水着)', image: Izumi_Swimsuit },
  Eimi: { name: 'エイミ', image: Eimi },
  Kayoko: { name: 'カヨコ', image: Kayoko },
  Kirino: { name: 'キリノ', image: Kirino },
  Kotori: { name: 'コトリ', image: Kotori },
  Koharu: { name: 'コハル', image: Koharu },
  Shun: { name: 'シュン', image: Shun },
  ShunYoung: { name: 'シュン(幼女)', image: Shun_Young },
  Zunko: { name: 'ジュンコ', image: Zunko },
  Shiroko: { name: 'シロコ', image: Shiroko },
  ShirokoRidingsuit: {
    name: 'シロコ(ライディング)',
    image: Shiroko_Ridingsuit
  },
  Suzumi: { name: 'スズミ', image: Suzumi },
  Sumire: { name: 'スミレ', image: Sumire },
  Serika: { name: 'セリカ', image: Serika },
  Cherino: { name: 'チェリノ', image: Cherino },
  CherinoHotSpring: { name: 'チェリノ(温泉)', image: CherinoHotSpring },
  Chise: { name: 'チセ', image: Chise },
  Tsubaki: { name: 'ツバキ', image: Tsubaki },
  Tsurugi: { name: 'ツルギ', image: Tsurugi },
  Tsurugi_Swimsuit: { name: 'ツルギ(水着)', image: Tsurugi_Swimsuit },
  Natsu: { name: 'ナツ', image: Natsu },
  Neru: { name: 'ネル', image: Neru },
  Neru_Bunny_Girl: { name: 'ネル(バニーガール)', image: Neru_Bunny_Girl },
  Nonomi: { name: 'ノノミ', image: Nonomi },
  Hasumi: { name: 'ハスミ', image: Hasumi },
  Hatsune_Miku: { name: 'ミク(コラボ)', image: Hatsune_Miku },
  Miku: { name: 'ミク', image: Hatsune_Miku },
  Haruka: { name: 'ハルカ', image: Haruka },
  Haruna: { name: 'ハルナ', image: Haruna },
  Hina: { name: 'ヒナ', image: Hina },
  Hina_Swimsuit: { name: 'ヒナ(水着)', image: Hina_Swimsuit },
  Hihumi: { name: 'ヒフミ', image: Hihumi },
  Hihumi_Swimsuit: { name: 'ヒフミ(水着)', image: Hihumi_Swimsuit },
  Pina: { name: 'フィーナ', image: Pina },
  Hoshino: { name: 'ホシノ', image: Hoshino },
  Maki: { name: 'マキ', image: Maki },
  Mari: { name: 'マリー', image: Mari },
  Midori: { name: 'ミドリ', image: Midori },
  Mutsuki: { name: 'ムツキ', image: Mutsuki },
  MutsukiNewyear: { name: 'ムツキ(正月)', image: MutsukiNewyear },
  Momoi: { name: 'モモイ', image: Momoi },
  Yuuka: { name: 'ユウカ', image: Yuuka },
  Yuzu: { name: 'ユズ', image: Yuzu },
  Airi: { name: 'アイリ', image: Airi },
  Ayane: { name: 'アヤネ', image: Ayane },
  Utaha: { name: 'ウタハ', image: Utaha },
  Karin: { name: 'カリン', image: Karin },
  Karin_Bunny_Girl: { name: 'カリン(バニーガール)', image: Karin_Bunny_Girl },
  Kotama: { name: 'コタマ', image: Kotama },
  Saya: { name: 'サヤ', image: Saya },
  Saya_Casual: { name: 'サヤ(私服)', image: Saya_Casual },
  Shizuko: { name: 'シズコ', image: Shizuko },
  Shimiko: { name: 'シミコ', image: Shimiko },
  Juri: { name: 'ジュリ', image: Juri },
  Serina: { name: 'セリナ', image: Serina },
  Chinatsu: { name: 'チナツ', image: Chinatsu },
  Fubuki: { name: 'フブキ', image: Fubuki },
  Sena: { name: 'セナ', image: Sena },
  Tomoe: { name: 'トモエ', image: Tomoe },
  Wakamo: { name: 'ワカモ', image: Wakamo },
  SerikaNewyear: { name: 'セリカ(正月)', image: Serika_Newyear },
  Chihiro: { name: 'チヒロ', image: Chihiro },
  ChinatsuHotSpring: { name: 'チナツ(温泉)', image: ChinatsuHotSpring },
  Nodoka: { name: 'ノドカ', image: Nodoka },
  NodokaHotSpring: { name: 'ノドカ(温泉)', image: NodokaHotSpring },
  Hanae: { name: 'ハナエ', image: Hanae },
  Hanako: { name: 'ハナコ', image: Hanako },
  Hare: { name: 'ハレ', image: Hare },
  Hibiki: { name: 'ヒビキ', image: Hibiki },
  Fuuka: { name: 'フウカ', image: Fuuka },
  Mashiro: { name: 'マシロ', image: Mashiro },
  Mashiro_Swimsuit: { name: 'マシロ(水着)', image: Mashiro_Swimsuit },
  Yoshimi: { name: 'ヨシミ', image: Yoshimi }
}

export const searchCharactor = (name: string) => {
  const chara = Object.entries(characterIdDict).find(
    ([_, v]) => v.name === name
  )
  if (!chara) return
  const [id, entry] = chara
  return { id, ...entry }
}

type SelectEntryType = {
  key: MotionEntryFields
  value: string
}

export const entryColumns: SelectEntryType[] = [
  { key: 'gsx$exカットイン', value: 'exカットイン' },
  { key: 'gsx$exモーション', value: 'exモーション' },
  { key: 'gsx$nsモーション', value: 'nsモーション' },
  { key: 'gsx$通常攻撃', value: '通常攻撃' },
  { key: 'gsx$リロード', value: 'リロード' },
  { key: 'gsx$リロード遮蔽', value: 'リロード遮蔽' },
  { key: 'gsx$遮蔽乗り越え', value: '遮蔽乗り越え' },
  { key: 'gsx$リザルト', value: 'リザルト' },
  { key: 'gsx$戦闘開始', value: '戦闘開始' },
  { key: 'gsx$つまみ', value: 'つまみ' },
  { key: 'gsx$カフェ絆', value: 'カフェ絆' },
  { key: 'gsx$カフェ歩き', value: 'カフェ歩き' },
  { key: 'gsx$カフェ待機', value: 'カフェ待機' },
  { key: 'gsx$その他', value: 'その他' },
  { key: 'gsx$メモロビ', value: 'メモロビ' },
  { key: 'gsx$メモロビ_2', value: 'メモロビ_2' },
  { key: 'gsx$誕生日', value: '誕生日' },
  { key: 'gsx$先生誕生日', value: '先生誕生日' }
]
